import { Component } from '@angular/core';
import { ReactPageComponent } from '../../../../common';
import { InvoicePage } from './page';

@Component({
  selector: 'app-page-invoices',
  template: '<div class="react-page" #container></div>'
})
export class PageInvoiceComponent extends ReactPageComponent {
  get Component(){
    return InvoicePage;
  }
}